import React, { useContext, useEffect, useState } from 'react'
import {
    mapData,
    converDate,
    getStateCode,
    getCountryCode,
} from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CustomDialog from '@/product/components/organisms/Dialog/index'

import VersaPayCardContext from '@/product/context/userThirdParty/payment/versapay/card/cardContext'
import AuthContext from '@/product/context/auth/authContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'
import Loaders from '@/product/components/molecules/Loaders'

function CyberSourceCardDetails(props) {
    const authContext = useContext(AuthContext)
    const productCommonContext = useContext(ProductCommonContext)
    const alertContext = useContext(AlertContext)
    const [loading, setLoading] = useState(false)
    const { setAlert } = alertContext
    const { user, loadUser } = authContext
    const {
        getPreviousData,
        clearPreviousData,
        previous_data,
        allCountries,
        allStates,
    } = productCommonContext
    const {
        get_all_card_details,
        createCard,
        createCardLink,
        get_card_link,
        deleteCard,
        updateCard,
        defaultCard,
        updateStripeCard,
        responseStatus,
        clearResponse,
    } = useContext(VersaPayCardContext)
    const [disabled, setDisabled] = useState(false)
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const cardType = [
        {
            value: 'CREDIT',
            show: 'Credit',
        },
        {
            value: 'DEBIT',
            show: 'Debit',
        },
    ]

    const cardBrand = [
        {
            value: '1',
            show: 'Visa',
        },
        {
            value: '2',
            show: 'Mastercard',
        },
        {
            value: '5',
            show: 'Discover',
        },
        {
            value: '6',
            show: 'Amex',
        },
    ]

    const [reload, setReload] = useState(false)
    const creditCardYearOptions = []
    let date = new Date()
    let currentYear = date.getFullYear()
    let upToYear = parseInt(currentYear) + 25
    for (let year = parseInt(currentYear); year < parseInt(upToYear); year++) {
        creditCardYearOptions.push({
            value: year,
            show: year,
        })
    }

    const validationCard = Yup.object({
        card_number: Yup.string()
            .min(12, 'Invalid credit card number!')
            .max(16, 'Invalid credit card number!')
            .required('Required!'),
        card_first_name: Yup.string()
            .trim()
            .matches(
                /^[a-zA-Z ]*$/g,
                'No Special Characters and Numbers Allowed'
            )
            .required('Required!'),
        card_last_name: Yup.string()
            .trim()
            .matches(
                /^[a-zA-Z ]*$/g,
                'No Special Characters and Numbers Allowed'
            )
            .required('Required!'),
        card_exp_month: Yup.string().required('Required!'),
        card_exp_year: Yup.string().required('Required!'),
        card_cvc: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'Only positive numbers allowed')
            .max(4, 'Maximum 4 Numbers required')
            .min(3, 'Mininum 3 Numbers required')
            .required('Required!'),
        card_address_line1: Yup.string().required('Required!'),
        card_address_line2: Yup.string(),
        card_address_city: Yup.string().required('Required!'),
        card_address_state: Yup.string().required('Required!'),
        card_address_country: Yup.string().required('Required!'),
        card_address_zip: Yup.string()
            .trim()
            .matches(
                /^[0-9A-Za-z-]*$/g,
                'Only numbers, hyphen and alphabets allowed'
            )
            .max(10, 'Maximum 10 characters')
            .min(4, 'Minimum 4 characters')
            .required('Required!'),
        card_type: Yup.string().required('Required!'),
        card_brand: Yup.string().required('Required!'),
        // phone: Yup.string().matches(phonenumber, 'Phone number is not valid'),
    })

    const cardFormik = useFormik({
        initialValues: {
            card_id: '',
            customer_id: user ? user.versapay_id : '',
            source_id: '',
            card_number: '',
            card_first_name: '',
            card_last_name: '',
            card_exp_month: '',
            card_exp_year: '',
            card_cvc: '',
            card_address_line1: '',
            card_address_line2: '',
            card_address_city: '',
            card_address_state: '',
            card_address_zip: '',
            card_type: 'CREDIT',
            card_brand: '',
            card_address_country: global.defaultCountry,
            is_primary: '',
            user_id: '',
            id: '',
            card_token: true,
            card_billing_id: '',
        },
        validationSchema: validationCard,
        onSubmit: (values) => {
            setLoading(true)
            let value = values
            createCardLink({
                ...value,
            })
        },
    })

    let currMonth = date.getMonth() + 1
    const creditCardMonthOptions = []
    let startMonth =
        parseInt(cardFormik.values?.card_exp_year, 10) <= currentYear
            ? currMonth
            : 1
    for (let month = parseInt(startMonth); month <= parseInt(12); month++) {
        let monthValue = ('0' + month).slice(-2)
        creditCardMonthOptions.push({
            value: ('0' + month).slice(-2),
            show: ('0' + month).slice(-2),
        })

        // creditCardMonthOptions.filter.push({
        //     value: ('0' + month).slice(-2),
        //     show: ('0' + month).slice(-2),
        // })
    }

    const validationupdateCard = Yup.object({
        card_number: Yup.string()
            .min(12, 'Invalid credit card number!')
            .max(16, 'Invalid credit card number!')
            .required('Required!'),
        card_first_name: Yup.string()
            .trim()
            .matches(
                /^[a-zA-Z ]*$/g,
                'No Special Characters and Numbers Allowed'
            )
            .required('Required!'),
        card_last_name: Yup.string()
            .trim()
            .matches(
                /^[a-zA-Z ]*$/g,
                'No Special Characters and Numbers Allowed'
            )
            .required('Required!'),
        card_exp_month: Yup.string().required('Required!'),
        card_exp_year: Yup.string().required('Required!'),
        card_cvc: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'Only positive numbers allowed')
            .max(4, 'Maximum 4 Numbers required')
            .min(3, 'Mininum 3 Numbers required')
            .required('Required!'),
        card_address_line1: Yup.string().required('Required!'),
        card_address_line2: Yup.string(),
        card_address_city: Yup.string().required('Required!'),
        card_address_state: Yup.string().required('Required!'),
        card_address_country: Yup.string().required('Required!'),
        card_address_zip: Yup.string()
            .trim()
            .matches(
                /^[0-9A-Za-z-]*$/g,
                'Only numbers, hyphen and alphabets allowed'
            )
            .max(10, 'Maximum 10 characters')
            .min(4, 'Minimum 4 characters')
            .required('Required!'),
        card_type: Yup.string().required('Required!'),
        card_brand: Yup.string().required('Required!'),
    })

    const updateCardformik = useFormik({
        initialValues: {
            card_id: '',
            customer_id: user ? user.versapay_id : '',
            source_id: '',
            card_number: '',
            card_first_name: '',
            card_last_name: '',
            card_exp_month: '',
            card_exp_year: '',
            card_cvc: '',
            card_address_line1: '',
            card_address_line2: '',
            card_address_city: '',
            card_address_state: '',
            card_address_zip: '',
            card_type: 'CREDIT',
            card_brand: '',
            card_address_country: global.defaultCountry,
            is_primary: '',
            user_id: '',
            id: '',
            card_token: true,
            card_billing_id: '',
        },
        validationSchema: validationupdateCard,
        onSubmit: (values) => {
            setLoading(true)
            let value = values
            createCardLink({
                ...value,
            })
        },
    })

    const formikSelection = useFormik({
        initialValues: {
            data: '',
            status: '',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (dataValue.status === 'delete') {
                console.log('props.data.data', props.data.data['billing-id'])
                deleteCard({
                    user_id: props.data.user_id,
                    id: props.data.data.id,
                })
                setChangeStatus(false)
                props.function(false, 'new', null)
            } else if (dataValue.status === 'default') {
                defaultCard({
                    user_id: props.data.user_id,
                    id: props.data.data.id,
                })
                setChangeStatus(false)
                props.function(false, 'new', null)
            }
        },
    })

    // useEffect(() => {
    //     console.log('here')
    //     if (previous_data) {
    //         if (previous_data.records.length) {
    //             // setAlert(
    //             //     'Removal of Card/ACH is permitted only after 6 weeks from the last bid',
    //             //     'error',
    //             // )
    //             // formikSelection.values.data = ''
    //             // formikSelection.values.status = ''
    //             // clearPreviousData()
    //             // props.function(false, 'new', null)
    //         } else if (formikSelection.values.status) {
    //             setChangeStatus(true)
    //         }
    //     }
    // }, [previous_data])

    useEffect(() => {
        if (cardFormik.values.card_number) {
            let string = cardFormik.values.card_number.toString()
            console.log(string, 'cardbrand')
            let firstChar = string.charAt(0)
            console.log(firstChar, 'firstt')
            if (firstChar == 3) {
                cardFormik.values.card_brand = '6'
            } else if (firstChar == 5) {
                cardFormik.values.card_brand = '2'
            } else if (firstChar == 4) {
                cardFormik.values.card_brand = '1'
            } else if (firstChar == 6) {
                cardFormik.values.card_brand = '5'
            } else {
                cardFormik.values.card_brand = ''
            }
        } else {
            cardFormik.values.card_brand = ''
        }
    }, [cardFormik.values.card_number])

    useEffect(() => {
        if (updateCardformik.values.card_number) {
            let string = updateCardformik.values.card_number.toString()
            console.log(string, 'cardbrand')
            let firstChar = string.charAt(0)
            console.log(firstChar, 'firstt')
            if (firstChar == 3) {
                updateCardformik.values.card_brand = '6'
            } else if (firstChar == 5) {
                updateCardformik.values.card_brand = '2'
            } else if (firstChar == 4) {
                updateCardformik.values.card_brand = '1'
            } else if (firstChar == 6) {
                updateCardformik.values.card_brand = '5'
            } else {
                updateCardformik.values.card_brand = ''
            }
        } else {
            updateCardformik.values.card_brand = ''
        }
    }, [updateCardformik.values.card_number])

    useEffect(() => {
        if (props.data.data) {
            if (props.data.status === 'delete') {
                formikSelection.values.data = props.data.data
                formikSelection.values.status = props.data.status
                setChangeStatus(true)
                // if (get_all_card_details.records.length > 1) {
                //     setChangeStatus(true)
                // } else {
                //     setAlert('Default card is required', 'error')
                //     setChangeStatus(false)
                //     props.function(false, 'new', null)
                // }
            } else if (props.data.status === 'default') {
                formikSelection.values.data = props.data.data
                formikSelection.values.status = props.data.status
                setChangeStatus(true)
            } else if (props.data.status === 'update') {
                const preFillAddress = props.preFillAddress || null
                console.log('props.data.data', props.data.data)
                updateCardformik.values.card_id = props.data.data.id
                updateCardformik.values.card_billing_id =
                    props.data.data.card_billing_id

                updateCardformik.values.card_first_name =
                    props.data.data.card_first_name
                updateCardformik.values.card_last_name =
                    props.data.data.card_last_name
                updateCardformik.values.card_number = ''
                updateCardformik.values.card_exp_month = (
                    '0' + props.data.data.card_exp_month
                ).slice(-2)
                updateCardformik.values.card_exp_year =
                    props.data.data.card_exp_year

                updateCardformik.values.card_cvc = ''

                updateCardformik.values.card_address_line1 = props.data.data
                    .card_address1
                    ? props.data.data.card_address1
                    : preFillAddress && preFillAddress.address1
                      ? preFillAddress.address1
                      : ''
                updateCardformik.values.card_address_line2 = props.data.data
                    .card_address2
                    ? props.data.data.card_address2
                    : preFillAddress && preFillAddress.address2
                      ? preFillAddress.address2
                      : ''

                updateCardformik.values.card_address_city = props.data.data
                    .card_city
                    ? props.data.data.card_city
                    : preFillAddress && preFillAddress.city
                      ? preFillAddress.city
                      : ''
                updateCardformik.values.card_address_country = props.data.data
                    .card_country
                    ? getCountryCode(allCountries, props.data.data.card_country)
                          .isoCode
                    : preFillAddress && preFillAddress.country
                      ? preFillAddress.country
                      : global.defaultCountry

                updateCardformik.values.card_address_state = props.data.data
                    .card_state
                    ? getStateCode(allStates, props.data.data.card_state)
                          .isoCode
                    : preFillAddress && preFillAddress.state
                      ? preFillAddress.state
                      : ''
                updateCardformik.values.card_address_zip = props.data.data
                    .card_postal
                    ? props.data.data.card_postal
                    : preFillAddress && preFillAddress.zip
                      ? preFillAddress.zip
                      : ''

                updateCardformik.values.card_type = 'CREDIT'
                updateCardformik.values.card_brand = ''

                setReload(!reload)
            }
        } else if (props.data.status === 'new') {
            const preFillAddress = props.preFillAddress || null
            cardFormik.values.card_id = ''
            cardFormik.values.card_billing_id = ''
            cardFormik.values.card_first_name = ''
            cardFormik.values.card_last_name = ''
            cardFormik.values.card_number = ''
            cardFormik.values.card_exp_month = ''
            cardFormik.values.card_exp_year = ''
            cardFormik.values.card_cvc = ''

            cardFormik.values.card_address_line1 = preFillAddress
                ? preFillAddress.address1
                : ''
            cardFormik.values.card_address_line2 = preFillAddress
                ? preFillAddress.address2
                    ? preFillAddress.address2
                    : ''
                : ''
            cardFormik.values.card_address_city = preFillAddress
                ? preFillAddress.city
                : ''
            cardFormik.values.card_address_state = preFillAddress
                ? preFillAddress.state
                : ''
            cardFormik.values.card_address_zip = preFillAddress
                ? preFillAddress.zip
                : ''
            cardFormik.values.card_type = 'CREDIT'
            cardFormik.values.card_brand = ''
            cardFormik.values.card_address_country = preFillAddress
                ? preFillAddress.country
                : global.defaultCountry
            setReload(!reload)
        }
    }, [props.data.data, props.data])

    useEffect(() => {
        if (props.data) {
            cardFormik.values.user_id = props.data.user_id
            updateCardformik.values.user_id = props.data.user_id
        }
    }, [props.data])

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'card_source_create' ||
                responseStatus.from === 'card_source_create_customer_card'
            ) {
                setDisabled(false)
            }
            setLoading(false)
        }
    }, [responseStatus])
    console.log('allStates', allStates)
    const cardUpdate = {
        formik: updateCardformik,
        data: [
            {
                label: 'Card Holder First Name',
                type: 'text',
                placeholder: 'Enter your card holder first name',
                class: 'col-6',
                name: 'card_first_name',
            },
            {
                label: 'Card Holder Last Name',
                type: 'text',
                placeholder: 'Enter your card holder last name',
                class: 'col-6',
                name: 'card_last_name',
            },
            {
                label: 'Card Number',
                type: 'number',
                placeholder: 'Enter your card number',
                class: 'col-12',
                name: 'card_number',
            },
            {
                label: 'Expiry Month',
                placeholder: 'MM',
                class: 'col-6',
                type: 'select',
                name: 'card_exp_month',
                options: creditCardMonthOptions,
            },
            {
                label: 'Expiry Year',
                placeholder: 'YYYY',
                class: 'col-6',
                type: 'select',
                name: 'card_exp_year',
                options: creditCardYearOptions,
            },
            {
                label: 'CVV',
                type: 'text',
                placeholder: 'Enter your Cvv',
                class: 'col-6',
                name: 'card_cvc',
            },
            // {
            //     class: 'col-6',
            //     type: 'misc',
            // },
            // {
            //     label: 'Card Type',
            //     placeholder: 'Select Card Type',
            //     class: 'col-6',
            //     type: 'select',
            //     name: 'card_type',
            //     options: cardType,
            // },
            {
                label: 'Card Brand',
                placeholder: 'Select Card Brand',
                class: 'col-6',
                type: 'select',
                name: 'card_brand',
                disabled: true,
                options: cardBrand,
            },
            {
                label: 'Card address line 1',
                type: 'text',
                placeholder: 'Enter card address line1',
                class: 'col-12',
                name: 'card_address_line1',
            },
            {
                label: 'Card address line 2',
                type: 'text',
                placeholder: 'Enter card address line2',
                class: 'col-12',
                name: 'card_address_line2',
            },
            {
                label: 'Card address city',
                type: 'text',
                placeholder: 'Enter card address city',
                class: 'col-12',
                name: 'card_address_city',
            },
            // {
            //     label: 'Card address state',
            //     type: 'text',
            //     placeholder: 'Enter card address state',
            //     class: 'col-12',
            //     name: 'card_address_state',
            // },
            // {
            //     label: 'Card address country',
            //     type: 'text',
            //     placeholder: 'Enter card address country',
            //     class: 'col-12',
            //     name: 'card_address_country',
            // },
            {
                label: 'Card address zip',
                type: 'text',
                placeholder: 'Enter card address zip',
                class: 'col-12',
                name: 'card_address_zip',
            },
            {
                label: 'Card address state',
                placeholder: 'Select card address state',
                class: 'col-12',
                type: 'select',
                options: allStates
                    .filter(
                        (state) =>
                            (updateCardformik.values.card_address_country
                                ? updateCardformik.values.card_address_country.indexOf(
                                      state.countryCode
                                  ) !== -1
                                : global.defaultCountry.indexOf(
                                      state.countryCode
                                  ) !== -1) &&
                            global.ignoreStates.indexOf(state.isoCode) === -1
                    )
                    .map((buscat) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = buscat.name
                        busCategoryChanged.value = buscat.isoCode
                        return busCategoryChanged
                    }),
                name: 'card_address_state',
            },
            {
                label: 'Card address country',
                placeholder: 'Select card address country',
                class: 'col-12',
                type: 'select',
                options: allCountries
                    ? allCountries
                          .filter(
                              (country) =>
                                  global.ignoreCountry.indexOf(
                                      country.isoCode
                                  ) === -1
                          )
                          .map((country) => {
                              let busCategoryChanged = {}
                              busCategoryChanged.show = country.name
                              busCategoryChanged.value = country.isoCode
                              return busCategoryChanged
                          })
                    : [],
                name: 'card_address_country',
            },
            // {
            //     label: 'Default Card',
            //     placeholder: 'Default Card',
            //     type: 'checkbox',
            //     class: 'col-sm-6 col-12',
            //     name: 'priority',
            // },
        ],
    }

    const cardDetails = {
        formik: cardFormik,
        data: [
            {
                label: 'Card Holder First Name',
                type: 'text',
                placeholder: 'Enter your card holder first name',
                class: 'col-6',
                name: 'card_first_name',
            },
            {
                label: 'Card Holder Last Name',
                type: 'text',
                placeholder: 'Enter your card holder last name',
                class: 'col-6',
                name: 'card_last_name',
            },
            {
                label: 'Card Number',
                type: 'number',
                placeholder: 'Enter your card number',
                class: 'col-12',
                name: 'card_number',
            },
            {
                label: 'Expiry Month',
                placeholder: 'MM',
                class: 'col-6',
                type: 'select',
                name: 'card_exp_month',
                options: creditCardMonthOptions,
            },
            {
                label: 'Expiry Year',
                placeholder: 'YYYY',
                class: 'col-6',
                type: 'select',
                name: 'card_exp_year',
                options: creditCardYearOptions,
            },
            {
                label: 'CVV',
                type: 'text',
                placeholder: 'Enter your Cvv',
                class: 'col-6',
                name: 'card_cvc',
            },
            // {
            //     label: 'Card Type',
            //     placeholder: 'Select Card Type',
            //     class: 'col-6',
            //     type: 'select',
            //     name: 'card_type',
            //     options: cardType,
            // },
            {
                label: 'Card Brand',
                placeholder: 'Select Card Brand',
                class: 'col-6',
                type: 'select',
                name: 'card_brand',
                disabled: true,
                options: cardBrand,
            },
            {
                label: 'Card address line 1',
                type: 'text',
                placeholder: 'Enter card address line1',
                class: 'col-12',
                name: 'card_address_line1',
            },
            {
                label: 'Card address line 2',
                type: 'text',
                placeholder: 'Enter card address line2',
                class: 'col-12',
                name: 'card_address_line2',
            },
            {
                label: 'Card address city',
                type: 'text',
                placeholder: 'Enter card address city',
                class: 'col-12',
                name: 'card_address_city',
            },
            // {
            //     label: 'Card address state',
            //     type: 'text',
            //     placeholder: 'Enter card address state',
            //     class: 'col-12',
            //     name: 'card_address_state',
            // },
            // {
            //     label: 'Card address country',
            //     type: 'text',
            //     placeholder: 'Enter card address country',
            //     class: 'col-12',
            //     name: 'card_address_country',
            // },
            {
                label: 'Card address zip',
                type: 'text',
                placeholder: 'Enter card address zip',
                class: 'col-12',
                name: 'card_address_zip',
            },
            {
                label: 'Card address state',
                placeholder: 'Select card address state',
                class: 'col-12',
                type: 'select',
                options: allStates
                    .filter(
                        (state) =>
                            (cardFormik.values.card_address_country
                                ? cardFormik.values.card_address_country.indexOf(
                                      state.countryCode
                                  ) !== -1
                                : global.defaultCountry.indexOf(
                                      state.countryCode
                                  ) !== -1) &&
                            global.ignoreStates.indexOf(state.isoCode) === -1
                    )
                    .map((buscat) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = buscat.name
                        busCategoryChanged.value = buscat.isoCode
                        return busCategoryChanged
                    }),
                name: 'card_address_state',
            },
            {
                label: 'Card address country',
                placeholder: 'Select card address country',
                class: 'col-12',
                type: 'select',
                options: allCountries
                    ? allCountries
                          .filter(
                              (country) =>
                                  global.ignoreCountry.indexOf(
                                      country.isoCode
                                  ) === -1
                          )
                          .map((country) => {
                              let busCategoryChanged = {}
                              busCategoryChanged.show = country.name
                              busCategoryChanged.value = country.isoCode
                              return busCategoryChanged
                          })
                    : [],
                name: 'card_address_country',
            },
            // {
            //     label: 'Default Card',
            //     placeholder: 'Default Card',
            //     type: 'checkbox',
            //     class: 'col-sm-6 col-12',
            //     name: 'priority',
            // },
        ],
    }

    useEffect(() => {
        if (get_card_link) {
            var formData = new FormData()
            console.log('props.data.status get_card_link', props.data.status)
            if (props.data.status === 'update') {
                formData.append(
                    'billing-cc-number',
                    updateCardformik.values.card_number
                )

                formData.append(
                    'billing-cc-exp',
                    `${updateCardformik.values.card_exp_month}${updateCardformik.values.card_exp_year}`
                )
                formData.append('billing-cvv', updateCardformik.values.card_cvc)
            } else {
                formData.append(
                    'billing-cc-number',
                    cardFormik.values.card_number
                )

                formData.append(
                    'billing-cc-exp',
                    `${cardFormik.values.card_exp_month}${cardFormik.values.card_exp_year}`
                )
                formData.append('billing-cvv', cardFormik.values.card_cvc)
            }

            createCard(get_card_link, formData)
            console.log('get_card_link', get_card_link)
        }
    }, [get_card_link])

    return (
        <>
            <CustomDialog
                open={props.data.popup && props.data.status === 'new'}
                size="md"
                className=""
                maxWidth="lg"
                function={() => props.function(false, 'new', null)}
                title="Add Card Details"
                closeBtn={true}
            >
                <Loaders name="home" isLoading={loading} />{' '}
                <div className="cardDetails">
                    <form
                        onSubmit={cardFormik.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div className="row">{mapData(cardDetails)}</div>
                        <div className="row">
                            <div className="col-12 d-flex">
                                <Button
                                    type="button"
                                    onClick={() =>
                                        props.function(false, 'update', null)
                                    }
                                >
                                    Cancel
                                </Button>
                                <PrimaryButton
                                    disabled={disabled}
                                    btnSize="large"
                                    type="submit"
                                    id="savecard_button"
                                    label={'Save'}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                title={'Confirmation'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.status === 'delete'
                        ? 'Are you sure you want to delete'
                        : formikSelection.values.status === 'default'
                          ? 'Are you sure you want to make this default card'
                          : 'Are you sure you want to change the status'}
                </h5>
                <div className="actionWrapper">
                    <Button onClick={() => changeChangeStatus()}>Cancel</Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                open={props.data.popup && props.data.status === 'update'}
                size="md"
                className=""
                maxWidth="lg"
                function={() => props.function(false, 'update', null)}
                title="Update Card Details"
                closeBtn={true}
            >
                <Loaders name="home" isLoading={loading} />{' '}
                <form
                    onSubmit={updateCardformik.handleSubmit}
                    autoComplete="nofill"
                >
                    <div className="row">
                        {mapData(cardUpdate)}
                        <div className="col-12 d-flex">
                            <Button
                                type="button"
                                onClick={() =>
                                    props.function(false, 'update', null)
                                }
                            >
                                Cancel
                            </Button>
                            <PrimaryButton
                                disabled={disabled}
                                btnSize="large"
                                type="submit"
                                id="updatecard_button"
                                label={'Save'}
                            />
                        </div>
                    </div>
                </form>
            </CustomDialog>
        </>
    )
}

export default CyberSourceCardDetails
